import Button from 'components/_core/Button';
import SunshineModal from 'components/_core/SunshineModal';
import Text from 'components/_core/Text';
import { useModal } from 'components/ModalProvider/hooks';

import { CLIENT_SAVE_CHANGES_ALERT_KEY } from '../../hooks/useClientFormModalContext';
import locales from './locales';

const SaveClientAlert = () => {
  const { hideModal } = useModal();

  const onStopAlert = () => {
    localStorage.setItem(CLIENT_SAVE_CHANGES_ALERT_KEY, Date.now().toString());
    hideModal();
  };

  return (
    <SunshineModal isOpen onClose={hideModal}>
      <SunshineModal.Header />

      <SunshineModal.Body>
        <SunshineModal.Title>{locales.title}</SunshineModal.Title>

        <Text>{locales.description}</Text>
      </SunshineModal.Body>

      <SunshineModal.Footer>
        <Button onClick={onStopAlert} variant="secondary">
          {locales.stopAlert}
        </Button>

        <Button onClick={hideModal}>{locales.next}</Button>
      </SunshineModal.Footer>
    </SunshineModal>
  );
};

export default SaveClientAlert;
